"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = exports.getMapState = exports.defaultProcessingSaga = exports.defaultResponseProcessing = exports.errorPut = exports.fetchResponse = exports.getAction = exports.createRequestBody = exports.createUrl = exports.DELAY_REACHABLE = exports.ERROR_LOCATION_CHANGE = exports.ERROR_CUSTOM_CANCEL = exports.ERROR_TIMEOUT_CANCEL = exports.CANCELABLE_LOCATION_DELAY = void 0;
var effects_1 = require("redux-saga/effects");
var config_1 = require("../config");
/**
 * Constants
 * */
exports.CANCELABLE_LOCATION_DELAY = 0; // create auto DELAY_REACHABLE
exports.ERROR_TIMEOUT_CANCEL = 'Response timed out';
exports.ERROR_CUSTOM_CANCEL = 'Custom cancel. Name: ';
exports.ERROR_LOCATION_CHANGE = 'Location change.';
exports.DELAY_REACHABLE = 30000;
// eslint-disable-next-line
function createUrl(url, payload, data, _query) {
    var result = '';
    if (typeof url !== 'string') {
        if (data && data.type && typeof data.type === 'string' && url[data.type]) {
            if (typeof url[data.type] === 'string') {
                if (url[data.type]) {
                    result = url[data.type];
                }
            }
            else {
                result = url[data.type](payload || {}, data);
            }
        }
    }
    else {
        result = url;
    }
    result = result.indexOf('://') === -1 ? config_1.config.api.url + result : result;
    if (_query) {
        var get = Object.keys(_query).map(function (key) { return "".concat(key, "=").concat(_query[key]); }).join('&');
        if (get) {
            result += (result.indexOf('?') === -1 ? '?' : '&') + get;
        }
    }
    return result;
}
exports.createUrl = createUrl;
// eslint-disable-next-line
function createRequestBody(entity, payload, data, _body) {
    var callback;
    if (_body) {
        if (payload instanceof FormData) {
            Object.keys(_body).forEach(function (key) {
                payload.append(key, _body[key]);
            });
        }
        else {
            Object.assign(payload, _body);
        }
    }
    if (entity.requestBody) {
        if (typeof entity.requestBody === 'function') {
            callback = entity.requestBody;
        }
        else if (data && data.type) {
            callback = entity.requestBody[data.type];
        }
    }
    return callback ? callback(payload) : payload;
}
exports.createRequestBody = createRequestBody;
var CANCELABLE_OPTIONS = {
    time: exports.CANCELABLE_LOCATION_DELAY,
    cancel: {},
    locationCancel: true,
};
var listStatusText = {
    0: 'Failed to get data. The server may not be available right now.',
    100: 'Continue',
    102: 'Processing',
    200: 'OK',
    201: 'Created',
    202: 'Accepted',
    204: 'No Content',
    400: 'Bad Request',
    401: 'Unauthorized',
    402: 'Payment Required',
    403: 'Forbidden',
    404: 'Not Found',
    405: 'Method Not Allowed',
    406: 'Not Acceptable',
    407: 'Proxy Authentication Required',
    408: 'Request Timeout',
    409: 'Conflict',
    426: 'Upgrade Required',
    429: 'Too Many Requests',
    499: 'Client Closed Request',
    500: 'Internal Server Error',
    501: 'Not Implemented',
    502: 'Bad Gateway',
    503: 'Service Unavailable',
    504: 'Gateway Timeout',
    520: 'Unknown Error',
    521: 'Web Server Is Down',
    522: 'Connection Timed Out',
    523: 'Origin Is Unreachable',
    524: 'A Timeout Occurred',
};
function getAction(name) {
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if ((_a = config_1.config.actions[name]) === null || _a === void 0 ? void 0 : _a.type) {
                    return [2 /*return*/, (_b = config_1.config.actions[name]) === null || _b === void 0 ? void 0 : _b.type];
                }
                return [4 /*yield*/, (0, effects_1.put)({
                        type: "".concat(config_1.config.auth.name, "/notValidAction"),
                        payload: {
                            name: name,
                        },
                    })];
            case 1:
                _c.sent();
                return [2 /*return*/, "".concat(config_1.config.auth.name, "/notValidAction/").concat(name)];
        }
    });
}
exports.getAction = getAction;
// eslint-disable-next-line
var fetchResponse = function (status, body) {
    var response = {
        status: status,
        ok: status >= 200 && status < 300,
        statusText: listStatusText[status] || 'fake response',
        body: '',
        json: function () { return ({}); },
        headers: new Headers(),
    };
    if (status === 204) {
        return response;
    }
    response.body = JSON.stringify(body);
    response.json = function () { return JSON.parse(response.body || ''); };
    return response;
};
exports.fetchResponse = fetchResponse;
function errorPut(action, response, err) {
    var message, type;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                message = (err === null || err === void 0 ? void 0 : err.message) || listStatusText[response.status];
                type = (err === null || err === void 0 ? void 0 : err.name) || 'undefined';
                if (typeof response.statusText === 'string') {
                    message = response.statusText || message;
                }
                else {
                    message = ((_a = response.statusText) === null || _a === void 0 ? void 0 : _a.message) || ((_b = response.statusText) === null || _b === void 0 ? void 0 : _b.messages) || message;
                    type = ((_c = response.statusText) === null || _c === void 0 ? void 0 : _c.type) || type;
                }
                return [4 /*yield*/, (0, effects_1.put)({
                        type: action,
                        payload: {
                            data: response.data,
                            status: response.status,
                            message: message,
                            type: type,
                        },
                    })];
            case 1:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
exports.errorPut = errorPut;
/**
 * @param {Object} response
 * @param {String} loadSuccess
 * @param {String} loadError
 * @param {(Generator|Function|Promise)} isValidData
 * @param {(Generator|Function|Promise)} prepareData
 *
 * @returns {IterableIterator<{payload: *, type: *}>|any | never | Promise<any>|IterableIterator<*>}
 */
function defaultResponseProcessing(response, loadSuccess, loadError, isValidData, prepareData) {
    var _a, _b, _c, data, type, _d, _e, _f, _g, _h, err_1;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                if (!(!response || (response === null || response === void 0 ? void 0 : response.message) === 'Failed to fetch')) return [3 /*break*/, 2];
                return [4 /*yield*/, errorPut(loadError, {
                        status: 0,
                        statusText: '',
                    }, {
                        name: 'Failed to fetch',
                    })];
            case 1:
                _j.sent();
                return [3 /*break*/, 23];
            case 2:
                if (!(response.ok && response.status === 204)) return [3 /*break*/, 7];
                _a = effects_1.put;
                _b = {
                    type: loadSuccess
                };
                if (!isValidData) return [3 /*break*/, 4];
                return [4 /*yield*/, isValidData()];
            case 3:
                _c = _j.sent();
                return [3 /*break*/, 5];
            case 4:
                _c = true;
                _j.label = 5;
            case 5: return [4 /*yield*/, _a.apply(void 0, [(_b.payload = _c,
                        _b)])];
            case 6:
                _j.sent();
                return [3 /*break*/, 23];
            case 7:
                _j.trys.push([7, 20, , 23]);
                data = void 0;
                type = response.headers.get('Content-Type');
                if (!(type === null || (type && type.indexOf('/json') !== -1))) return [3 /*break*/, 9];
                return [4 /*yield*/, response.json()];
            case 8:
                data = (_j.sent());
                _j.label = 9;
            case 9:
                _d = data && response.status >= 200 && response.status < 300;
                if (!_d) return [3 /*break*/, 12];
                _e = typeof isValidData !== 'function';
                if (_e) return [3 /*break*/, 11];
                return [4 /*yield*/, isValidData(data, response)];
            case 10:
                _e = (_j.sent());
                _j.label = 11;
            case 11:
                _d = (_e);
                _j.label = 12;
            case 12:
                if (!_d) return [3 /*break*/, 17];
                _f = effects_1.put;
                _g = {
                    type: loadSuccess
                };
                if (!prepareData) return [3 /*break*/, 14];
                return [4 /*yield*/, prepareData(data, response)];
            case 13:
                _h = _j.sent();
                return [3 /*break*/, 15];
            case 14:
                _h = data;
                _j.label = 15;
            case 15: return [4 /*yield*/, _f.apply(void 0, [(_g.payload = _h,
                        _g)])];
            case 16:
                _j.sent();
                return [3 /*break*/, 19];
            case 17: return [4 /*yield*/, errorPut(loadError, {
                    data: data,
                    statusText: (response === null || response === void 0 ? void 0 : response.message)
                        || (response === null || response === void 0 ? void 0 : response.error)
                        || response.statusText
                        || listStatusText[response.status]
                        || '',
                    status: response.status,
                })];
            case 18:
                _j.sent();
                _j.label = 19;
            case 19: return [3 /*break*/, 23];
            case 20:
                err_1 = _j.sent();
                if (!(err_1 instanceof Error)) return [3 /*break*/, 22];
                return [4 /*yield*/, errorPut(loadError, response, err_1)];
            case 21:
                _j.sent();
                _j.label = 22;
            case 22: return [3 /*break*/, 23];
            case 23: return [2 /*return*/];
        }
    });
}
exports.defaultResponseProcessing = defaultResponseProcessing;
function errorHandling(error, action, event) {
    var payload, _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                payload = {
                    message: event === null || event === void 0 ? void 0 : event.message,
                    type: listStatusText[((event === null || event === void 0 ? void 0 : event.status) || 0)],
                    status: 499,
                };
                if ((event === null || event === void 0 ? void 0 : event.message) && (event === null || event === void 0 ? void 0 : event.name)) {
                    Object.assign(payload, {
                        message: event === null || event === void 0 ? void 0 : event.message,
                        type: event === null || event === void 0 ? void 0 : event.name,
                    });
                }
                if (!(typeof error === 'function')) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, effects_1.call)(error, action, payload)];
            case 1:
                _c.sent();
                return [3 /*break*/, 7];
            case 2:
                if (!!error) return [3 /*break*/, 5];
                _a = effects_1.put;
                _b = {};
                return [4 /*yield*/, getAction('cancelableSagaError')];
            case 3: return [4 /*yield*/, _a.apply(void 0, [(_b.type = _c.sent(),
                        _b.payload = payload,
                        _b)])];
            case 4:
                _c.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, (0, effects_1.put)({
                    type: error,
                    payload: payload,
                })];
            case 6:
                _c.sent();
                _c.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
function tryCatch(catchSaga, catchError, action) {
    var err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 5]);
                return [4 /*yield*/, (0, effects_1.call)(catchSaga, action)];
            case 1:
                _a.sent();
                return [3 /*break*/, 5];
            case 2:
                err_2 = _a.sent();
                if (!(err_2 instanceof Error)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, effects_1.call)(errorHandling, catchError, action, err_2)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
/**
 * Sagas
 *
 * Generator that cancels the function at a certain interval or if change the route.
 *
 * @param {(Generator|Function|Promise)} saga // return yield call(saga, actions)
 * @param {Object} options // optional
 *        default: {
 *          error: {(Generator|Function|Promise|String)} error // return yield call(error, actions, event)
 *          time: Number, // timeout cancels the function
 *          cancel: {
 *            ...
 *            // example - position: take(GET_CURRENT_POSITION_ERROR)
 *            ...
 *          },
 *          locationCancel: true | string (Action)
 *        }
 * @param {Any} actions // call(saga, ACTIONS) and call(error, ACTIONS, event)
 */
function defaultProcessingSaga(saga, _a) {
    var error = _a.error, options = __rest(_a, ["error"]);
    return function cancelable(action) {
        var _a, time, cancel, locationCancel, timeout, raceList, list, key;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = __assign(__assign({}, CANCELABLE_OPTIONS), options), time = _a.time, cancel = _a.cancel, locationCancel = _a.locationCancel;
                    timeout = (time || exports.DELAY_REACHABLE) | 0;
                    raceList = __assign(__assign({}, cancel), { timeoutCancel: (0, effects_1.delay)(timeout), taskLoad: (0, effects_1.call)(tryCatch, saga, error, action) });
                    return [4 /*yield*/, (0, effects_1.race)(raceList)];
                case 1:
                    list = (_b.sent());
                    key = Object.keys(list)[0];
                    if (!(key === 'timeoutCancel')) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, effects_1.call)(errorHandling, error, action, {
                            message: exports.ERROR_TIMEOUT_CANCEL,
                            status: 408,
                            timeout: timeout,
                        })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 8];
                case 3:
                    if (!(key === 'locationCancel')) return [3 /*break*/, 6];
                    if (!(locationCancel && typeof locationCancel === 'string')) return [3 /*break*/, 5];
                    return [4 /*yield*/, (0, effects_1.call)(errorHandling, locationCancel, action, {
                            message: exports.ERROR_LOCATION_CHANGE,
                            status: 499,
                        })];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    if (!(key !== 'taskLoad')) return [3 /*break*/, 8];
                    return [4 /*yield*/, (0, effects_1.call)(errorHandling, error, action, {
                            message: exports.ERROR_CUSTOM_CANCEL,
                            status: 499,
                            key: key,
                        })];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    };
}
exports.defaultProcessingSaga = defaultProcessingSaga;
function getMapState(data, list, entityName) {
    if (entityName === void 0) { entityName = config_1.config.auth.name; }
    var result = {};
    list.forEach(function (key) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (data[entityName] && typeof data[entityName][key] !== 'undefined') {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            result[key] = data[entityName][key];
        }
    });
    return result;
}
exports.getMapState = getMapState;
function getConfig(name) {
    var entity = config_1.config[name];
    Object.assign(entity, {
        fetchDelay: typeof entity.fetchDelay !== 'undefined' ? entity.fetchDelay : config_1.config.fetchDelay,
        delayBeforeStart: typeof entity.delayBeforeStart !== 'undefined' ? entity.delayBeforeStart : config_1.config.delayBeforeStart,
        delaySuccess: typeof entity.delaySuccess !== 'undefined' ? entity.delaySuccess : config_1.config.delaySuccess,
        delayWarning: typeof entity.delayWarning !== 'undefined' ? entity.delayWarning : config_1.config.delayWarning,
        delayError: typeof entity.delayError !== 'undefined' ? entity.delayError : config_1.config.delayError,
    });
    return entity;
}
exports.getConfig = getConfig;
